import React, { useContext } from 'react';
import {UserContext} from "../context/UserContext";
import IdleTimerInner from './IdleTimerInner';

function IdleTimer({ children, logout }) {
    const { userIP, secureIpAddresses } = useContext(UserContext);

    const ipReady = userIP !== null && userIP !== undefined;
    const secureListReady = Array.isArray(secureIpAddresses);
    const timerReady = ipReady && secureListReady;

    if (!timerReady) return <>{children}</>;

    return <IdleTimerInner logout={logout}>{children}</IdleTimerInner>;
}
export default IdleTimer;
